const labelClass = 'mb-1.5 block text-sm font-medium text-slate-700';

export default function LogoTab({ style, updateStyle }) {
  const handleFile = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith('image/')) return;

    const reader = new FileReader();
    reader.onload = () => updateStyle('logoUrl', reader.result);
    reader.readAsDataURL(file);
    e.target.value = '';
  };

  return (
    <div className="space-y-6">
      <div>
        <label htmlFor="logo-upload" className={labelClass}>
          Center logo
        </label>
        <input
          id="logo-upload"
          type="file"
          accept="image/png,image/jpeg,image/webp,image/svg+xml"
          onChange={handleFile}
          className="block w-full text-sm text-slate-600 file:mr-4 file:rounded-lg file:border-0 file:bg-indigo-50 file:px-4 file:py-2 file:text-sm file:font-medium file:text-indigo-700 hover:file:bg-indigo-100"
        />
        <p className="mt-2 text-xs text-slate-500">
          PNG or JPG with transparent background works best. Uses high error correction.
        </p>
      </div>

      {style.logoUrl && (
        <>
          <div className="flex items-center gap-4">
            <img
              src={style.logoUrl}
              alt="Logo preview"
              className="h-16 w-16 rounded-lg border border-slate-200 bg-white object-contain p-1"
            />
            <button
              type="button"
              onClick={() => updateStyle('logoUrl', '')}
              className="text-sm font-medium text-red-600 hover:text-red-700"
            >
              Remove logo
            </button>
          </div>
          <div>
            <label htmlFor="logo-size" className={labelClass}>
              Logo size: {Math.round(style.logoSize * 100)}%
            </label>
            <input
              id="logo-size"
              type="range"
              min={0.15}
              max={0.45}
              step={0.05}
              value={style.logoSize}
              onChange={(e) => updateStyle('logoSize', Number(e.target.value))}
              className="h-2 w-full cursor-pointer accent-indigo-600"
            />
          </div>
          <div>
            <label htmlFor="logo-margin" className={labelClass}>
              Logo margin: {style.logoMargin}px
            </label>
            <input
              id="logo-margin"
              type="range"
              min={0}
              max={20}
              step={1}
              value={style.logoMargin}
              onChange={(e) => updateStyle('logoMargin', Number(e.target.value))}
              className="h-2 w-full cursor-pointer accent-indigo-600"
            />
          </div>
        </>
      )}
    </div>
  );
}

